import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Row } from 'reactstrap';
import NumberFormat from 'react-number-format';

class ConsumerCreateAccount extends Component {
  render() {
    return (
      <div className="page-preapproved narrow">
        <Container>
          <Row>
            <Col xs={12} className="text-center">
              <img src="/images/servicingusa-logo.svg" alt="ServicingUSA Sign In" className="mb-4" />
              <Row>
                <Col sm={{size: 8, offset: 2}} md={{size: 6, offset: 3}} lg={{size: 4, offset: 4}}>
                  <Card className="dark-shadow">
                    <CardHeader>Create New Account</CardHeader>
                    <CardBody>
                      <FormGroup>
                        <Label for="SSN">SSN</Label>
                        <NumberFormat customInput={Input} format="###-##-####" />
                      </FormGroup>
                      <FormGroup>
                        <Label for="userEmail">Email Address</Label>
                        <Input type="email" name="user-email" id="userEmail" />
                      </FormGroup>
                      <Button color="primary" className="w-100 mb-2">Next</Button>
                      <small>This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy" target="_new">Privacy Policy</a> and <a href="https://policies.google.com/terms" target="_new">Terms of Service</a> apply.</small>
                    </CardBody>
                  </Card>
                  <Row>
                    <Col xs={12}>
                      <Link to="/consumer/signin">Back to Sign In</Link>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default ConsumerCreateAccount;
